import React, {useState, useEffect} from "react";
import { DashboardEA } from "../../../network/api/DashboardEA";
import { encodeId } from "../../../../../../../utils/hash";
import { Link } from "react-router-dom";
import ButtonLoader from "../../../../../../../components/ButtonLoader";

export default function TopSellingEA({userId = null}) {
    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(null);
    const [eaData, setEaData] = useState(null);

    useEffect(() => {
        const fetchEAData = async () => {
            try {
                const response = await DashboardEA({owner: userId});
                if (response.status === "success") {
                    setEaData(response.data);
                } else {
                    setErrorMessage({status:response.status ,message:response.message});
                }
            } catch (error) {
                setErrorMessage({status:400 ,message:"Failed to fetch EA data"});
            } finally {
                setIsLoading(false);
            }
        };

        fetchEAData();
    }
    , [userId]);
    return (
        <Link to={`/eas/${encodeId(eaData?.ea_id)}`} className="card">
            <div className="card-header border-0 pb-0">
                <h4 className="mb-0">{errorMessage ? errorMessage.message : eaData?.ea_name}</h4>
                <span>{isLoading ? <ButtonLoader /> :"Top Selling"}</span>
            </div>
            <div className="card-body">

                <div className="progress mb-4" style={{ height: "13px" }}>
                    <div className="progress-bar bg-danger progress-animated" style={{ width: `${(eaData?.expired/eaData?.owners_total)*100}%`, height: "13px" }} role="progressbar">
                        <span className="sr-only">{(eaData?.expired/eaData?.owners_total)*100}% Complete</span>
                    </div>
                </div>
                <div className="progress mb-4" style={{ height: "13px" }}>
                    <div className="progress-bar bg-success progress-animated" style={{ width: `${(eaData?.active/eaData?.owners_total)*100}%`, height: "13px" }} role="progressbar">
                        <span className="sr-only">{(eaData?.active/eaData?.owners_total)*100}% Complete</span>
                    </div>
                </div>
                <div className="progress default-progress" style={{ height: "13px" }}>
                    <div className="progress-bar bg-primary progress-animated" style={{ width: `${(eaData?.total/eaData?.owners_total)*100}%`, height: "13px" }} role="progressbar">
                        <span className="sr-only">{(eaData?.total/eaData?.owners_total)*100}% Complete</span>
                    </div>
                </div>
                <div className="d-flex mt-4 progress-bar-legend align-items-center justify-content-between">
                    <div className="d-flex">
                        <span className="marker bg-danger"></span>
                        <div>
                            <p className="status">Expired</p>
                            <span className="result">{eaData?.expired}</span>
                        </div>
                    </div>
                    <div className="d-flex">
                        <span className="marker bg-success"></span>
                        <div>
                            <p className="status">Active</p>
                            <span className="result">{eaData?.active}</span>
                        </div>
                    </div>
                    <div className="d-flex">
                        <span className="marker bg-primary"></span>
                        <div>
                            <p className="status">Total</p>
                            <span className="result">{eaData?.total}</span>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
}